import { Link } from 'gatsby';
import { useEffect, useState } from 'react';
import { useLocation } from '@reach/router';

// @todo remove header.css import after styles refactoring
import '../styles/header.css';
import '../styles/menu.css';

import { _ } from '../utils/l10n';
import ArrowRightPrimary from '../assets/icons/arrow-fwd-primary.svg';
import ChevronDownPrimary from '../assets/icons/chevron-down-primary.svg';

interface NavLink {
  label: string;
  items: {
    [key: string]: string;
  };
}

export interface NavLinks {
  [key: string]: string | NavLink;
}

const MenuLink = ({ to, label }: { to: string, label: string }) => (
  <Link
    to={to}
    className="menu-item underline-animation"
    activeClassName="underline-active"
  >
    {label}
    {/* @todo replace image with CSS pseudo selector */}
    <img
      src={ArrowRightPrimary}
      alt="arrow forward"
      className="menu-item-arrow-right"
    />
  </Link>
);


const MenuItem = ({ pathFragment, value, openSecondLevelMenu, setOpenSecondLevelMenu } : {
  pathFragment: string;
  value: string | NavLink;
  openSecondLevelMenu: string | null;
  setOpenSecondLevelMenu: (key: string | null) => void;
}) => {

  const key = pathFragment;
  const location = useLocation();
  const isParent = typeof value === 'object';
  const isParentActive = isParent && key === location.pathname.split('/')[1];
  const isParentOpen = isParent && key === openSecondLevelMenu;

  const toggleSecondLevelMenu = (key: string) => {
    isParent && setOpenSecondLevelMenu(openSecondLevelMenu === key ? null : key);
  };

  const getMenuItemContainerClass = () => {
    let classNames = ['menu-item-container'];
    isParent && classNames.push('second-nav-container');
    isParentOpen && classNames.push('second-nav-open');
    return classNames.join(' ');
  }

  const getMenuItemClass = () => {
    let classNames = ['menu-item', 'underline-animation', 'button-reset'];
    isParent && classNames.push('second-level-top-link');
    isParentActive && classNames.push('underline-active');
    return classNames.join(' ');
  }
  // @todo improve and simplify html markup
  return (
    <li
      className={getMenuItemContainerClass()}
    >
      {!isParent ? (
        <MenuLink to={`/${key}/`} label={value} />
      ) : (
        <button
          className={getMenuItemClass()}
          aria-haspopup="true"
          aria-expanded={isParentOpen}
          onClick={() => toggleSecondLevelMenu(key)}
        >
          {value.label}
          {/* @todo replace image with CSS pseudo selector */}
          <img
            src={ChevronDownPrimary}
            alt="chevron down"
            className="nav-chevron-down"
          />
        </button>
      )}
      {isParentOpen && (
        <div className="second-level-nav-menu-container">
          <ul className="second-level-nav-menu">
            {Object.entries(value.items).map(([subKey, subValue]) => (
              <li key={subKey}>
                <MenuLink to={`/${key}/${subKey}`} label={subValue} />
              </li>
            ))}
          </ul>
        </div>
      )}
    </li>
  );

};


export const MenuItems = ({ items, className, isMobileMenuOpen }: {
  items: NavLinks;
  className?: string;
  isMobileMenuOpen?: boolean;
}) => {
  const [openSecondLevelMenu, setOpenSecondLevelMenu] = useState<string | null>(null);

  useEffect(() => {
    isMobileMenuOpen || setOpenSecondLevelMenu(null);
  }, [isMobileMenuOpen]);

  return (
    <ul className={`menu-items ${className || ''}`}>
      {Object.entries(items).map(([key, value]) =>
        <MenuItem
          key={key}
          pathFragment={key}
          value={value}
          openSecondLevelMenu={openSecondLevelMenu}
          setOpenSecondLevelMenu={setOpenSecondLevelMenu}
        />
      )}
    </ul>
  );
};
